(function () {
  function initStickyAfterFirstSection() {
    const header = document.querySelector(
      '#header-component.header.sticky-after-first-section'
    );

    if (!header) return;

    const firstSection = document.querySelector(
      '#MainContent .shopify-section'
    );

    if (!firstSection) return;

    if (header.dataset.stickyInit === 'true') return;
    header.dataset.stickyInit = 'true';

    const observer = new IntersectionObserver(
      function ([entry]) {
        if (!entry.isIntersecting) {
          requestAnimationFrame(() => {
            header.classList.add('is-sticky');
          });
        } else {
          header.classList.remove('is-sticky');
        }
      },
      { threshold: 0 }
    );

    observer.observe(firstSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAfterFirstSection);
  } else {
    initStickyAfterFirstSection();
  }

  document.addEventListener('shopify:section:load', initStickyAfterFirstSection);
})();

// header height 

// document.addEventListener("DOMContentLoaded", () => {
//     const header = document.querySelector(
//         ".header-section"
//     );
//     const firstSection = document.querySelector("#MainContent .section-wrapper");

//     if (!header || !firstSection) return;
    
//     const applySpacing = () => {
//         const headerHeight = header.offsetHeight;
//         firstSection.style.marginTop = `-${headerHeight}px`;
//     };

//     applySpacing();
//     window.addEventListener("resize", applySpacing);
// });

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-section");
  const firstSection = document.querySelector("#MainContent .section-wrapper");

  if (!header || !firstSection) return;

  const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
          const headerHeight = entry.target.offsetHeight;
          
          if (headerHeight > 0) {
              firstSection.style.setProperty("margin-top", `-${headerHeight}px`, "important");
          }
      }
  });

  resizeObserver.observe(header);
});

document.addEventListener("DOMContentLoaded", () => {
  const header1 = document.querySelector(".header-section");
  const firstSection1 = document.querySelector("#MainContent #faq-title");

  if (!header1 || !firstSection1) return;

  const resizeObserver1 = new ResizeObserver(entries => {
      for (let entry of entries) {
          const headerHeight1 = entry.target.offsetHeight;
          
          if (headerHeight1 > 0) {
              firstSection1.style.setProperty("margin-top", `-${headerHeight1}px`, "important");
          }
      }
  });

  resizeObserver1.observe(header1);
});

// home image delay
document.addEventListener("DOMContentLoaded", function () {
  const img = document.querySelector(
    ".hero__content-wrapper img.image-block__image.border-style"
  );

  const text = document.querySelector(
    ".hero__content-wrapper .h1"
  );

  setTimeout(() => {
    if (img) {
      img.classList.add("is-visible");
      setTimeout(() => img.classList.add("blur-clear"), 200);
    }

    if (text) {
      text.classList.add("is-visible");
      setTimeout(() => text.classList.add("blur-clear"), 200);
    }
  }, 1000);
});

// form textarea field row :- 

document.addEventListener("DOMContentLoaded", function () {
    const textarea = document.getElementById("ContactForm-body");
    if (!textarea) return;

    function updateRows() {
      if (window.innerWidth < 749) {
        textarea.rows = 7;
      } else {
        textarea.rows = 4;
      }
    }
    updateRows();
    window.addEventListener("resize", updateRows);
});
const injectTaxNotice = () => {
  const dialog = document.querySelector('quick-add-dialog, #quick-add-modal, .quick-add-modal');
  
  if (dialog) {
    const targetSpan = dialog.querySelector('.product-form-buttons.spacing-style.product-form-buttons--stacked');
    const scrollContainer = dialog.querySelector('.product-form-buttons.spacing-style.product-form-buttons--stacked');

    if (targetSpan && !dialog.querySelector('.custom-product-extras')) {

      if (!dialog.querySelector('.product-tax-notice')) {
        const taxText = document.createElement('div');
        taxText.className = 'product-tax-notice';
        taxText.style.cssText = 'display:block !important; font-size:13px !important; color:#667131 !important; margin-bottom:10px !important;';
        taxText.innerHTML = `*Tax included`;
        targetSpan.insertAdjacentElement('beforebegin', taxText);
      }

      const extrasContainer = document.createElement('div');
      extrasContainer.className = 'custom-product-extras';
      
      extrasContainer.style.cssText = `
        display: block !important;
        visibility: visible !important;
        width: 100% !important;
        margin-top: 24px !important;
        clear: both !important;
      `;

      extrasContainer.innerHTML = `
        <div class="custom-text-popup-div" style="margin-bottom: 12px !important; display: block !important;">
          <div class="custom-popup-div" style="display: flex !important; align-items: flex-start !important; gap: 8px !important;">
            <span style="color: #667131 !important; font-weight: bold !important; font-size: 18px !important; line-height: 1 !important;">✓</span>
            <div class="custom-text-popup" style="font-size: 14px !important; color: #667131 !important; line-height: 130% !important;">
               <span style="color: #667131 !important;font-size: 14px !important;letter-spacing:-0.14px;">Pickup available at <strong>Deagon Store</strong></span>
              <span style="color: #667131 !important; display: block !important;font-size: 14px !important;letter-spacing:-0.14px; margin-top:8px; margin-bottom:8px;">Usually ready in 24 hours</span>
              <a href="/" style="color: #667131 !important; text-decoration: underline !important; font-size: 14px !important;letter-spacing:-0.14px; display: inline-block !important; ">View store information</a>
            </div>
          </div>
        </div>
        <div class="custom-text-p-div" style="margin-top: 24px !important; display: block !important;">
          <p style="color:#667131; font-size:14px;letter-spacing:-0.14px;font-style: italic;font-weight:400;">
            *Please note that due to seasonal availability, images shown are indicative of the colour pallete and style we will create, all photos are our large & wow size. We cannot guarantee exact flower varieties due to seasonal availability (especially roses)
          </p>
        </div>
      `;

      if (scrollContainer) {
        scrollContainer.appendChild(extrasContainer);
        console.log("ATTACHED TO SCROLL CONTAINER");
      } else {
        targetSpan.parentElement.appendChild(extrasContainer);
        console.log("FALLBACK TO PARENT ELEMENT");
      }
    }
  }
};

setInterval(injectTaxNotice, 500);

document.addEventListener('click', function (e) {

  const button = e.target.closest(
    '.page-cart #quick-add-modal-content .button.add-to-cart-button'
  );

  if (button) {

    document.body.style.transition = 'opacity 0.4s ease';
    document.body.style.opacity = '0.6';

    setTimeout(function () {
      location.reload();
    }, 500);

  }

});